$.fn.bindFirst = function (name, fn) {
	this.bindNth(name, fn, 0);
};

$.fn.bindNth = function(name, fn, index) {
	// Bind event normally.
	this.bind(name, fn);
	// Move to nth position.
	this.changeEventOrder(name, index);
};

$.fn.changeEventOrder = function (names, newIndex) {
	var that = this;
	// Allow for multiple events.
	$.each(names.split(' '), function (idx, name) {
		that.each(function () {
			var handlers = $._data(this, 'events')[name.split('.')[0]];
			// Validate requested position.
			newIndex = Math.min(newIndex, handlers.length - 1);
			handlers.splice(newIndex, 0, handlers.pop());
		});
	});
};



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/helpers/events.js